"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const Label = (_a) => {
    var { className = '', for: htmlFor, check = false, inline = false, disabled = false, children } = _a, props = __rest(_a, ["className", "for", "check", "inline", "disabled", "children"]);
    const labelClasses = (0, classnames_1.default)(className, {
        'form-check-label': check, // Adds Bootstrap styles for checkbox/radio
        'form-check-inline': inline, // Adds inline styling for checkbox/radio
        disabled, // Adds disabled styling
    });
    return ((0, jsx_runtime_1.jsx)("label", Object.assign({ className: labelClasses, htmlFor: htmlFor }, props, { children: children })));
};
exports.Label = Label;
